import { render, staticRenderFns } from "./AuthConfirmAttention.vue?vue&type=template&id=656547f6&scoped=true"
import script from "./AuthConfirmAttention.vue?vue&type=script&lang=js"
export * from "./AuthConfirmAttention.vue?vue&type=script&lang=js"
import style0 from "./AuthConfirmAttention.vue?vue&type=style&index=0&id=656547f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656547f6",
  null
  
)

export default component.exports